import React, { useEffect, useState } from "react";
import { Title, Text } from "rizzui/typography";
import { Button, Box } from "rizzui";
import { Link, useNavigate } from "react-router";
import { useModal } from "../../../hooks/useModal";
import ImportFile from "../../../component/cards/importFile";
import PopUp from "../../../component/popUp";

export default function ProjectCreated({ id }: { id?: string }) {
  const navigate = useNavigate();
  const { openModal } = useModal();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleClick = () => {
    openModal({
      view: (
        <ImportFile page="leads" type="csv" shouldShowSingleEntry id={id} />
      ),
    });
  };

  return (
    <div className="place-items-center w-full h-lvh place-content-center">
      <PopUp />
      <Box className="w-[379px] rounded-[8px] border-[.5px] border-muted p-[32px]">
        <div className="mb-[32px]">
          <Title className="text-[18px] leading-[23.4px] font-[600] text-primary-dark mb-[8px] text-center font-ibmPlexSerif">
            Campaign created
          </Title>
          <Text className="text-[14px] leading-[18.48px] font-[400] text-[#758599] text-center font-switzer">
            Your campaign is ready! Just import leads to get it up and running.
          </Text>
        </div>

        <div className="text-secondary-dark font-switzer">
          <Button
            variant="solid"
            className="!bg-btn rounded-[4px] w-full mb-[2px] font-switzer leading-[15.84px] text-[12px] font-[500]"
            isLoading={isLoading}
            onClick={handleClick}
          >
            Import contacts
          </Button>
        </div>
        <Text className="text-[12px] mt-3 -mb-3 font-switzer font-[400] text-[#758599] text-center">
          Go to{" "}
          <Link to={"/campaigns"} className="underline font-bold">
            campaigns
          </Link>
        </Text>
      </Box>
    </div>
  );
}
